import { AddOrderNotes } from '../components/AddOrderNotes';
import { Button, Divider } from '@orthly/ui-primitives';
import React from 'react';

interface ChatActionProps {
    orderId?: string;
    isMobile?: boolean;
    setAddOrderNotesDialogOpen?: (addOrderNotesDialogOpen: boolean) => void;
    openChat: () => void;
    showAddOrderNotes: boolean;
}

export const ChatActionContent: React.FC<ChatActionProps> = ({ orderId, openChat, showAddOrderNotes }) => {
    return (
        <>
            <Button leftAlign variant={'ghost'} startIcon={'SidebarChatIcon'} onClick={openChat}>
                Chat with us
            </Button>
            {showAddOrderNotes && orderId && (
                <>
                    <Divider />
                    <AddOrderNotes orderId={orderId} />
                </>
            )}
        </>
    );
};
